import {MultiSelectPicker} from '@github-ui/filter-picker'

import {getReposItemConfig} from './ItemConfig'
import {MultiSelectReposPickerDialog} from './MultiSelectReposPickerDialog'
import type {MultiSelectReposProps} from './types'

export function MultiSelectReposPicker(props: MultiSelectReposProps) {
  const {isOpenInitially, ['aria-describedby']: ariaDescribedby, ...dialogProps} = props
  const itemConfig = getReposItemConfig(dialogProps.scope)

  return (
    <MultiSelectPicker
      aria-describedby={ariaDescribedby}
      isOpenInitially={isOpenInitially}
      itemConfig={itemConfig}
      selected={dialogProps.selected}
      renderDialog={publicProps => <MultiSelectReposPickerDialog {...publicProps} {...dialogProps} />}
    />
  )
}

try{ MultiSelectReposPicker.displayName ||= 'MultiSelectReposPicker' } catch {}